"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryReceiptSchema = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
const buildFileSchema_1 = require("../validation/buildFileSchema");
exports.deliveryReceiptSchema = (0, buildFileSchema_1.buildFileSchema)({
    shipmentKey: fluent_json_schema_1.default.string().required(),
    proNumber: fluent_json_schema_1.default.string(),
    organizationName: fluent_json_schema_1.default.string(),
    organizationId: fluent_json_schema_1.default.string(),
    referenceNumber: fluent_json_schema_1.default.string().required(),
    updatedByUserKey: fluent_json_schema_1.default.string().required(),
});
//# sourceMappingURL=DeliveryReceiptFile.js.map